// extracted by mini-css-extract-plugin
export default {"container":"Xp9t","tableScroll":"_3YQB"};